import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-collection-statements',
  templateUrl: './collection-statements.html',
  styleUrls: ['./collection-statements.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollectionStatementsComponent {}
